import React from 'react';
import { isEmpty } from '@docavenue/core';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { round } from 'lodash';
import { useRouter } from 'next/router';
import { analyticsEvent } from '@/src/analytic_tag_manager';
import Avatar from '../../atoms/Avatar/Avatar';
import { getPictureSource } from '../../utils/card';
import { isOnlineTlc } from '../../../src/utils';
import { ListMode } from '../SearchResults/types';

interface Props {
  mode?: ListMode;
  item: CardHcd;
  onClick: () => void;
}

const SearchCardAvatarInfo: React.FC<Props> = ({ item, mode, onClick }) => {
  const { pathname } = useRouter();
  const substitute = item?.substituteData;
  let avatarSource =
    item.type === 'CENTER' && !getPictureSource(item)
      ? '/static/images/default_center.svg'
      : getPictureSource(item);

  if (!isEmpty(substitute) && pathname.includes('teleconsultation')) {
    avatarSource = '/static/images/avatar-substitute.svg';
  }
  const onAvatarClick = React.useCallback(() => {
    analyticsEvent({
      category: 'PractitionersAndCentersResults',
      action: 'ClickCardPicture',
    });

    onClick();
  }, [onClick]);

  // upcomingTlc require an appointment so IsOnline is not relevant
  const isOnline = React.useMemo(
    () => (mode === 'tlc' ? isOnlineTlc(item) : false),
    [],
  );

  return (
    <div className="search-card__avatar">
      <Avatar
        size="big"
        isOnline={isOnline}
        source={avatarSource}
        onClick={onAvatarClick}
      />
      {item?.distance ? (
        <span className="avatar--info">{`${round(item.distance, 1)} km`}</span>
      ) : null}
    </div>
  );
};

SearchCardAvatarInfo.displayName = 'SearchCardAvatarInfo';

export default React.memo(
  SearchCardAvatarInfo,
  (oldProps, newProps) => oldProps.item.id === newProps.item.id,
);
